module.exports = __webpack_public_path__ + "img/_5.4136ca72.png";